<cs-header>
  <cs-header-title>{{ LL.dbRestoreJson.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <cs-card>
      <cs-card-content>
        <cs-note>{{ LL.dbRestoreJson.description() }}</cs-note>

        <input id="restore-file-input" style="visibility: hidden; position: absolute;" type="file" accept=".json"
          (change)="handleFileChange($event)" />

        <cs-button secondary icon="folder-open" (click)="handleChooseFile()"
          [label]="LL.dbRestoreJson.chooseFile()"></cs-button>

        @if (loadedFileName) {
          <cs-note small>{{ loadedFileName }}</cs-note>
        }

        <cs-note small class="or-divider">{{ LL.dbRestoreJson.orPaste() }}</cs-note>

        <cs-textarea [(value)]="pastedJson"
          [placeholder]="LL.dbRestoreJson.pasteHint()">
        </cs-textarea>

        <cs-button secondary (click)="handleParseFromTextarea()"
          [label]="LL.dbRestoreJson.parseJson()"></cs-button>

        @if (parseError) {
          <cs-note error>{{ parseError }}</cs-note>
        }

        @if (parsedDocs) {
          <cs-note>{{ LL.dbRestoreJson.fileLoaded({ count: parsedDocs.length }) }}</cs-note>
        }
      </cs-card-content>
    </cs-card>

  </cs-card-list>
</cs-content>

<cs-page-action-buttons>
  <cs-button primary medium [disabled]="!parsedDocs" (click)="handleRestore()"
    [label]="LL.dbRestoreJson.restore()"></cs-button>
</cs-page-action-buttons>
